<template>
  <div style="height: 100%"></div>
</template>

<script>
  import * as echarts from 'echarts';
  import { mapGetters } from 'vuex'
  export default {
    name: "barChart",
    props: {chartData: Object},
    data() {
      return {
        chart: null,
        resizeHandler: null
      }
    },
    computed: {
      ...mapGetters([
        'isCollapse'
      ])
    },
    watch: {
      isCollapse() {
        this.resizeChart();
      },
      chartData: {
        deep: true,
        handler(val) {
          this.setOptions(val);
        }
      }
    },
    methods: {
      resizeChart() {
        this.chart.resize();
      },
      initChart() {
        this.chart = echarts.init(this.$el);
        this.setOptions(this.chartData);
      },
      setOptions({title, label, barList, showLegend} = {}) {
        this.chart.clear();
        this.chart.setOption({
          title: {
            text: title
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            top: 45,
            left: '2%',
            right: '2%',
            bottom: '3%',
            containLabel: true
          },
          yAxis: [{
            type: 'value',
            axisTick: {
              show: false
            },
            axisLabel:{
              interval:0,
              formatter:function(val){
                return  "￥" + val;
              }
            }
          }],
          xAxis: [{
            type: 'category',
            data: label,
            axisTick: {
              alignWithLabel: true
            },
          }],
          legend: {
            right: '5%',
            show: showLegend,
          },
          series: barList.map(bar => {
            return {
              name: bar.name,
              type: 'bar',
              stack: 'vistors',//数据堆叠
              barWidth: '60%',
              data: bar.data,
              animationDuration: 3000,
              itemStyle: {
                color: bar.color
              },
            }
          })
        })
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initChart();
        this.resizeHandler = () => {
          this.resizeChart();
        };
        window.addEventListener("resize", this.resizeHandler);
      })
    },
    beforeDestroy() {
      if (this.chart) {
        this.chart.dispose()
      }
      window.removeEventListener("resize", this.resizeHandler);
    }
  }
</script>

<style scoped>

</style>
